import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Checkbox } from '@/components/ui/checkbox'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { useCurrentUser } from '@/features/auth/state/auth'

import { useNavigate } from 'react-router-dom'
import { useUpdateUserLiAceito } from '@/features/users/services/useUpdateUserLiAceito'

import { FeedbackDialog } from './feedback-dialog'

import { ROUTES } from '@/config/routes'

interface TermsOfTestemunhaProps {
  onAccept?: () => Promise<void> | void
  title?: string
  buttonLabel?: string
}

export function TermsOfTestemunha({
  onAccept,
  title = 'Termo de Testemunha',
  buttonLabel = 'Aceitar'
}: TermsOfTestemunhaProps = {}) {
  const [accepted, setAccepted] = useState(false)
  const user = useCurrentUser()
  const navigate = useNavigate()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [message, setMessage] = useState<{
    type: 'success' | 'error'
    text: string
  } | null>(null)

  const { mutate: updateUser } = useUpdateUserLiAceito()

  useEffect(() => {
    if (user?.li_aceito) {
      navigate(ROUTES.CEP.path)
    }
  }, [user, navigate])
  const handleAccept = async () => {
    if (onAccept) {
      try {
        await onAccept()
        setMessage({
          type: 'success',
          text: 'O termo foi aceito com sucesso!'
        })
        setIsDialogOpen(true)
      } catch (error) {
        setMessage({
          type: 'error',
          text: 'Houve um erro ao aceitar o termo.'
        })
        setIsDialogOpen(true)
      }
      return
    }

    if (!user) {
      setMessage({
        type: 'error',
        text: 'Usuário não autenticado.'
      })
      return
    }

    if (accepted) {
      updateUser(
        { data: { li_aceito: true } },
        {
          onSuccess: () => {
            setMessage({
              type: 'success',
              text: 'Os termos de uso foram aceitos com sucesso!'
            })
            setIsDialogOpen(true) // Abre o modal
            navigate(ROUTES.CEP.path)
          },
          onError: () => {
            setMessage({
              type: 'error',
              text: 'Houve um erro ao aceitar os termos de uso.'
            })
          }
        }
      )
    } else {
      setMessage({
        type: 'error',
        text: 'Ação Necessária! Por favor, aceite os termos antes de prosseguir.'
      })
    }
  }


  return (
    <div className="min-h-screen flex justify-center items-center ">
      <Card className="w-full max-w-3xl mx-auto">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[180px] pr-4">
            <div className="space-y-4 text-sm">
              <h2 className="text-lg font-semibold">Aceitação dos Termos de Testemunha</h2>
              <p>
                Este contrato está sendo assinado sem as testemunhas neste momento. O usuário declara ciência 
                da ausência das testemunhas e se compromete a providenciar as assinaturas posteriormente.
              </p>
              <p>
                Declaro, ainda, que a ausência momentânea das testemunhas não decorre de vício de consentimento, 
                coação ou desconhecimento do conteúdo contratual, tendo eu lido, compreendido e aceitado integralmente os termos do instrumento.
              </p>
            </div>
            <FeedbackDialog
              isOpen={isDialogOpen}
              onOpenChange={open => {
                setIsDialogOpen(open)
                if (!open && message?.type === 'success') {
                  // navigate('/cep') // Só navega se fechou e foi sucesso
                }
              }}
              message={message}
            />
          </ScrollArea>
        </CardContent>
        <CardFooter className="flex flex-col items-start space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox id="terms" checked={accepted} onCheckedChange={checked => setAccepted(checked as boolean)} />
            <label
              htmlFor="terms"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Eu li e aceito os termos.
            </label>
          </div>
          <Button onClick={handleAccept} disabled={!accepted} className="w-full">
            {buttonLabel}
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
